import { render } from "./CastellsDrawing-Component.vue?vue&type=template&id=697508d0"
import script from "./CastellsDrawing-Component.vue?vue&type=script&lang=js"
export * from "./CastellsDrawing-Component.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__